import React from "react";
import CartHeaderButton from "../cart-header-button/CartHeaderButton";
import './MahutiHeader.css'
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import { PREFIX_PATH } from "../../utils/GlobalParams";
import { useDispatch, useSelector } from "react-redux";
import { clearAll } from "../../utils/orderUtils";

export default function MahutiHeader() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const store = useSelector(store => store.reducer);
    let lpPrefix = store.lpName ? '/' + store.lpName : '';

    return <nav className="main-header navbar navbar-expand-lg bg-lg-light">
        <div className="container-fluid">
            {isMobile ? <><div className="mobile_menu_con d-flex align-items-center"> 
                <button className="navbar-toggler me-2" type="button" data-bs-toggle="collapse" data-bs-target="#mahutiLinks" aria-controls="mahutiLinks" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="main-logo ms-2">
                    <a href="https://www.mahuti.co.il"><img src="https://www.mahuti.co.il/wp-content/themes/mahuti/images/img-logo-mahuti-header.svg" alt="מהותי – פעילות עם מהות" /></a>
                </div>
            </div>
            <CartHeaderButton /></> :
            
            <div className="main-logo me-2">
                <div className="reset_store" onClick={() => {clearAll(dispatch); navigate(PREFIX_PATH + lpPrefix);}}></div>
                <a href="https://www.mahuti.co.il"><img src="https://www.mahuti.co.il/wp-content/themes/mahuti/images/img-logo-mahuti-header.svg" alt="מהותי – פעילות עם מהות" /></a>
            </div>}

            <div className="collapse navbar-collapse" id="mahutiLinks">
                <ul className="navbar-nav me-auto mt-3 mt-lg-0 mb-2 mb-lg-0 almoni_tzar_light text-lg-center text-start">
                    <li className="nav-item">
                        <a className="mahutiLink" href="https://www.mahuti.co.il/about/">אודות</a>
                    </li>
                    <li className="nav-item">
                        <a className="mahutiLink" href="https://www.mahuti.co.il/online/">מהותי אונליין</a>
                    </li>
                    <li className="nav-item">
                        <a className="mahutiLink" href="https://www.mahuti.co.il/parents_and_kids-2/">לכל המשפחה</a>
                    </li>
                    <li className="nav-item">
                        <a className="mahutiLink" href="https://www.mahuti.co.il/kids_and_teens_groups/">קבוצות ילדים ונוער</a>
                    </li>
                    <li className="nav-item">
                        <a className="mahutiLink" href="https://www.mahuti.co.il/organizations_and_groups/">ארגונים וקבוצות</a>
                    </li>
                    <li className="nav-item">
                        <a className="mahutiLink" href="https://www.mahuti.co.il/merchav/">מרחב מהותי</a>
                    </li>
                    <li className="nav-item">
                        <a className="mahutiLink" href="https://www.mahuti.co.il/blog/">בלוג</a>
                    </li>
                    <li className={`nav-item align-items-center d-flex ${isMobile ? 'justify-content-start' : 'justify-content-center mx-3'}`}>
                        {isMobile ? <a className="mahutiLink" href="https://www.mahuti.co.il/purchase/">צרו קשר</a> : <a className="mahutiLink envelop" href="https://www.mahuti.co.il/purchase/"></a>}
                    </li>
                </ul>

                {!isMobile && <CartHeaderButton />}
            </div>
        </div>
    </nav >
}